import { ReactNode } from "react";

import { Stack, StackProps, Theme, SxProps } from "@mui/material";

import { mergeSx } from "@/common/helpers/mergeSx";

export type LiveEditorBlockProps = StackProps & {
  children: ReactNode;
};

export const LiveEditorBlock = ({ children, sx, ...rest }: LiveEditorBlockProps) => {
  const baseSx: SxProps<Theme> = (theme) => ({
    width: "100%",
    paddingX: { xs: 2, md: 3 },
    paddingY: 2,
    backgroundColor: theme.palette.surface.neutral.supershy,
    borderRadius: 1,
  });

  return (
    <Stack sx={mergeSx(baseSx, sx)} {...rest}>
      {children}
    </Stack>
  );
};
